import Gauge from './Gauge'

export default Gauge

export { Gauge }
